// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "number-YPyBc";
var _4 = "header-1RyeM";
var _5 = "filled-1Fs03";
var _6 = "passengerName-2kgC7";
var _7 = "payload-10x0G";
export { _1 as "__esModule", _2 as "mobile", _3 as "number", _4 as "header", _5 as "filled", _6 as "passengerName", _7 as "payload" }
export default { "__esModule": _1, "mobile": _2, "number": _3, "header": _4, "filled": _5, "passengerName": _6, "payload": _7 }
